import styles from './FooterBtn.module.css';
import { useNavigate } from 'react-router-dom';

export const FooterBtn = ({ img, title, description, width, height, url, onClick }) => {
	const navigate = useNavigate();

	return (
		<div 
			className={styles.main}
			style={{ maxWidth: width, minHeight: height }}
			onClick={() =>{
				onClick !== undefined && onClick();
					url?.includes('http')
						? window.Telegram.WebApp.openTelegramLink(url)
						: navigate(url)
				}
			}
		>
			<img src={img} alt="btnImg" />
			<p className={styles.title}>{title}</p>
			<p className={styles.description}>{description}</p>
		</div>
	);
};

